import React, { useEffect, useState, useRef } from 'react';
import useWindowSize from '../../../../hooks/useWindowSize';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { isEmpty } from 'lodash';
import queryString from 'query-string';

import HtmlTooltip from '../../../../components/HtmlTooltip/HtmlTooltip';
import EquipmentContextMenu from './EquipmentContextMenu';
import BobLoadingMask from '../../../../components/BobLoadingMask';
import DeleteCoreEntityModal from '../../Modals/DeleteCoreEntityModal';

import { process as kendoProcess } from '@progress/kendo-data-query';
import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import { calculateMinColumnWidths } from '../../../../helpers/calculateMinColumnWidths';

import * as K2ACoreActions from '../../../../actions/k2aCoreActions';
import * as TableActions from '../../../../actions/tableActions';
import { kendoGridInlineStyling } from '../../../../helpers/kendoGridInlineStyleHelper';
import * as classes from '../EntitiesPage.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const CoreEquipmentTable = ({
    activeNavCompany,
    activeNavClient,
    activeNavSite,
    bobLoading,
    deleteCoreEquipment,
    equipment,
    equipmentMeta,
    fetchCoreEquipment,
    fetchCoreEquipmentByClient,
    fetchCoreEquipmentBySite,
    history,
    refreshTab,
    setRefreshTab,
    searchTerm,
    setCoreEquipment,
    tableProps,
    updateTableProps,
    view,
    workbookModeEnabled,
    ...props
}) => {

    const [dataState, setDataState] = useState(initialDataState);
    const [deleteEquipmentModalOpen, setDeleteEquipmentModalOpen] = useState(false);
    const [selectedEquipment, setSelectedEquipment] = useState({});
    const [pageable] = useState({ pageSizes: true });
    const [selectedEquipmentList, setSelectedEquipmentList] = useState([]);
    const [tableState, setTableState] = useState('');
    const [equipmentNameColumnWidth, setEquipmentNameColumnWidth] = useState(450);
    const [take, setTake] = useState(10);

    const queryValues = queryString.parse(history.location.search);

    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setEquipmentNameColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'name', 450, true));
    }, [windowSize]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
    }, [workbookModeEnabled]);

    useEffect(() => {
        const init = async () => {
            if (queryValues.childId === '0da7cfdd-f757-4231-8979-7ff2b806e0a5' && (tableState !== 'company' && (equipmentMeta.entity && equipmentMeta.entity !== 'company'))) {
                await fetchCoreEquipment(activeNavCompany.id, { page: 1, limit: dataState.take });
            } else if (queryValues.childId === '7e2354df-ebb5-4c68-a1a4-57cc84dd61eb' && (tableState !== 'client' && (equipmentMeta.entity && equipmentMeta.entity !== 'client'))) {
                await fetchCoreEquipmentByClient(activeNavClient.id, { page: 1, limit: dataState.take });
            } else if (queryValues.childId === '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd' && (tableState !== 'site' && (equipmentMeta.entity && equipmentMeta.entity !== 'site'))) {
                await fetchCoreEquipmentBySite(activeNavSite.id, { page: 1, limit: dataState.take });
            }

        };
        if (activeNavCompany.id) init();
    }, [queryValues.childId]);

    useEffect(() => {
        const init = async () => {
            if (queryValues.childId === '0da7cfdd-f757-4231-8979-7ff2b806e0a5') {
                await fetchCoreEquipment(activeNavCompany.id, { page: 1, limit: dataState.take });
                setTableState('company');
            }
        };

        if (activeNavCompany.id && !equipmentMeta.isActive) {
            init();
        } else if (activeNavCompany.id && equipmentMeta.isActive && equipmentMeta.company !== activeNavCompany.id) {
            init();
        }


    }, [activeNavCompany]);

    useEffect(() => {
        const init = async () => {
            if (queryValues.childId === '7e2354df-ebb5-4c68-a1a4-57cc84dd61eb') {
                await fetchCoreEquipmentByClient(activeNavClient.id, { page: 1, limit: dataState.take });
                setTableState('client');
            }
        };

        if (activeNavClient.id && !equipmentMeta.isActive) {
            init();
        } else if (activeNavClient.id && equipmentMeta.isActive && equipmentMeta.client !== activeNavClient.id) {
            init();
        }
    }, [activeNavClient]);

    useEffect(() => {
        const init = async () => {
            if (queryValues.childId === '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd') {
                await fetchCoreEquipmentBySite(activeNavSite.id, { page: 1, limit: dataState.take });
                setTableState('site');
            }
        };

        if (activeNavSite.id && !equipmentMeta.isActive) {
            init();
        } else if (activeNavSite.id && equipmentMeta.isActive && equipmentMeta.site !== activeNavSite.id) {
            init();
        }
    }, [activeNavSite]);

    useEffect(() => {
        if (tableProps.coreEquipment) {
            let updatedDataState = { ...dataState };
            updatedDataState.skip = (tableProps.coreEquipment.page * tableProps.coreEquipment.limit) - tableProps.coreEquipment.limit;
            updatedDataState.take = tableProps.coreEquipment.limit;
            setDataState(updatedDataState);
        }
    }, [tableProps]);

    useEffect(() => {
        setSelectedEquipmentList(equipment);
    }, [equipment]);

    useEffect(() => {
        setSelectedEquipmentList(equipment.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase())));
    }, [searchTerm]);

    useEffect(() => {
        const refresh = async () => {
            setRefreshTab(view);
            if (view === 'Company Equipment') {
                await fetchCoreEquipment(activeNavCompany.id, { page: 1, limit: dataState.take });
            } else if ( view === 'Client Equipment') {
                await fetchCoreEquipmentByClient(activeNavClient.id, { page: 1, limit: dataState.take });
            } else if ( view === 'Site Equipment') {
                await fetchCoreEquipmentBySite(activeNavSite.id, { page: 1, limit: dataState.take });
            }

            if (searchTerm) {
                setSelectedEquipmentList(equipment.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase())));
            }

            setRefreshTab('');
        };

        if (refreshTab) refresh();
    }, [refreshTab]);
    
    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <EquipmentContextMenu
                    dataItem={props.dataItem}
                    setCoreEquipment={setCoreEquipment}
                    setDeleteEquipmentModalOpen={setDeleteEquipmentModalOpen}
                    setSelectedEquipment={setSelectedEquipment}
                />
            </td>
        );
    };

    const renderClientNameCell = props => {
        const client = props.dataItem.extendedData.client[0];
        return (
            <td>
                {client?.name}
            </td>
        );
    };

    const renderSiteNameCell = props => {
        const site = props.dataItem.extendedData.site[0];
        return (
            <td>
                {site?.name}
            </td>
        );
    };

    const renderEquipmentTypeCell = props => {
        const equipmentType = props.dataItem.equipmentType.name;

        return (
            <td>
                {equipmentType}
            </td>
        );
    };

    const renderManufacturerCell = props => {
        const manufacturer = props.dataItem.manufacturer;

        return (
            <td>
                {manufacturer ? manufacturer.name : ''}
            </td>
        );
    };

    const renderAreaCell = props => {
        const areas = props.dataItem.extendedData.areas;
        let areaList = '';
        if (!isEmpty(areas) && areas.length > 1) {
            areaList = areas.map(area => {
                return <div key={area.id} style={{paddingTop: '.35rem', paddingBottom: '0.35rem', fontSize: '1.2rem'}}>{area.name}</div>;
            });
        }

        if (areas.length <= 1) {
            return (
                <td>
                    {areas.length === 1 ? areas[0].name : ''}
                </td>
            );
        }
        else {
            return (
                <td>
                    <HtmlTooltip
                        information={
                            <span className={classes.Tooltip}>
                                {areaList}
                            </span>
                        }
                        placement="top-start"
                        body={
                            <span>
                                {areas.length + ' Areas'}
                            </span>
                        }
                    />
                </td>
            );
        }
    };

    const renderSystemCountCell = props => {
        const systemCount = props.dataItem.extendedData.totalSystemCount;

        return (
            <td>
                {systemCount}
            </td>
        );
    };

    const handleDeleteEquipment = async () => {
        await deleteCoreEquipment(selectedEquipment.id);

        if (!isEmpty(activeNavSite)) {
            await fetchCoreEquipmentBySite(activeNavSite.id, { page: 1, limit: dataState.take, searchFilter: searchTerm });
        } else if (!isEmpty(activeNavClient)) {
            await fetchCoreEquipmentByClient(activeNavClient.id, { page: 1, limit: dataState.take, searchFilter: searchTerm });
        } else {
            await fetchCoreEquipment(activeNavCompany.id, { page: 1, limit: dataState.take, searchFilter: searchTerm });
        }
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    return (
        <React.Fragment>
            <style>
                { kendoGridInlineStyling }
            </style>
            <div ref={gridDivRef} className={classes.Table}>
                <Grid
                    ref={gridRef}
                    sortable={{
                        mode: 'multiple'
                    }}
                    className={classes.KendoGrid}
                    data={kendoProcess(selectedEquipmentList, dataState)}
                    {...dataState}
                    onDataStateChange={onDataStateChange}
                    filterable={workbookModeEnabled}
                    pageable={pageable}
                    reorderable
                >
                    {
                        bobLoading.includes('FetchCoreEquipment')  ?
                            <GridNoRecords>
                                Loading equipment
                            </GridNoRecords>
                            : null
                    }
                    <Column
                        field="name"
                        title="Equipment"
                        id={'equipmentColumn'}
                        width={equipmentNameColumnWidth}
                    />
                    <Column
                        field="extendedData.client[0].name"
                        title="Client"
                        width={200}
                        cell={renderClientNameCell}
                    />
                    <Column
                        field="extendedData.site[0].name"
                        title="Site"
                        cell={renderSiteNameCell}
                        width={200}
                        id={'siteColumn'}
                    />
                    <Column
                        field="equipmentType.name"
                        title="Equipment Type"
                        width={175}
                        cell={renderEquipmentTypeCell}
                    />
                    <Column
                        field="manufacturer.name"
                        title="Manufacturer"
                        width={175}
                        cell={renderManufacturerCell}
                    />
                    <Column
                        field="model"
                        title="Model Number"
                        width={150}
                    />
                    <Column
                        field="serialNumber"
                        title="Serial Number"
                        width={150}
                    />
                    <Column
                        field="extendedData.totalSystemCount"
                        title="Associated System"
                        width={175}
                        cell={renderSystemCountCell}
                    />
                    <Column
                        field="extendedData.areas[0].name"
                        title="Area"
                        width={150}
                        cell={renderAreaCell}
                    />
                    <Column
                        field=""
                        title=""
                        locked={true}
                        sortable={false}
                        filterable={false}
                        width={80}
                        cell={actionsCell}
                    />
                </Grid>
                {
                    deleteEquipmentModalOpen ?
                        <DeleteCoreEntityModal
                            entity={{ ...selectedEquipment, type: 'Equipment' }}
                            handleDeleteEntity={handleDeleteEquipment}
                            toggleModalOpen={setDeleteEquipmentModalOpen}
                        />
                        :
                        null
                }
                {
                    bobLoading.includes('FetchCoreEquipment') || isEmpty(equipmentMeta) ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    activeNavClient:  state.bob.activeNavClient,
    activeNavSite:    state.bob.activeNavSite,
    bobLoading:       state.bob.bobLoading,
    equipment:        state.k2aCore.equipment,
    equipmentMeta:    state.k2aCore.equipmentMeta,
    tableProps:       state.tableProps
});

const mapDispatchToProps = ({
    ...K2ACoreActions,
    ...TableActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CoreEquipmentTable));
